var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObjStoreHoverIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9834 16.4167C11.225 16.5417 11.225 19.0917 12.9834 19.2167H17.1584C17.6667 19.2167 18.15 19.0334 18.525 18.6917C19.7584 17.6167 19.1 15.45 17.475 15.25C16.8917 11.7334 11.8 13.0667 13.0084 16.4167",
    fill: "#0C0507"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9834 16.4167C11.225 16.5417 11.225 19.0917 12.9834 19.2167H17.1584C17.6667 19.2167 18.15 19.0334 18.525 18.6917C19.7584 17.6167 19.1 15.45 17.475 15.25C16.8917 11.7334 11.8 13.0667 13.0084 16.4167",
    fill: "#BDCEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 9.22496V12.7833C18.3334 13.05 17.9084 13.1666 17.725 12.975C17.3334 12.5666 16.8417 12.2583 16.275 12.0833C14.9667 11.675 13.4584 12.075 12.5084 13.0583C11.9084 13.7 11.5834 14.5 11.5667 15.3666C11.5667 15.5166 11.4917 15.65 11.375 15.7416C10.775 16.2166 10.4084 16.9583 10.4084 17.8083V17.8166C10.4084 18.0833 10.2167 18.325 9.95002 18.325H6.11669C3.66669 18.3333 1.66669 16.3333 1.66669 13.875V5.34996C1.66669 3.31663 3.31669 1.66663 5.35002 1.66663H7.28335C8.64169 1.66663 9.06669 2.10829 9.60835 2.83329L10.775 4.38329C11.0334 4.72496 11.0667 4.76663 11.55 4.76663H13.875C15.8584 4.76663 17.5417 6.06663 18.1167 7.86663C18.2417 8.24163 18.3084 8.62496 18.325 9.03329C18.3334 9.09163 18.3334 9.16663 18.3334 9.22496Z",
    fill: "url(#paint0_linear_38_11289)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_11289",
    x1: 10,
    y1: -0.345253,
    x2: 10,
    y2: 18.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjStoreHoverIc);
export default __webpack_public_path__ + "static/media/obj-store-hover-ic.1f6e56aa5655c1ca6b2a5d55ba380f95.svg";
export { ForwardRef as ReactComponent };